var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticClass:"line_echarts",attrs:{"options":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }